module.exports = __webpack_public_path__ + "static/media/siic.a0ddc151.png";